/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

export function NumberSpin(props) {
  const { em, data } = props;
  const { parentSize } = em || {};
  const floating = em && em.floating ? em.floating : false;
  const groupClass = (floating ? '' : 'row') + ' ' + (em && em.class ? em.class : '');
  const labelClass = floating ? 'label' : `col-sm-${parentSize === 'full' ? '2' : '5'} col-form-label`;
  const inputClass =
    (floating ? '' : `col-sm-${parentSize === 'full' ? '10' : '7'}`) +
    (em && em.align ? ` text-${em.align}` : ` text-right`);

  const [value, setValue] = useState((props.data && em.field && props.data[em.field]) || '');

  // const handleDefaultChange = useCallback((e) => {}, []);

  const formatter = Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: em && em.digits !== undefined ? em.digits : props.digits !== undefined ? props.digits : 0,
    maximumFractionDigits: 0, // em.digits !== undefined ? em.digits : props.digits !== undefined ? props.digits : 0,
  });
  const refInput = useRef(null);

  useEffect(() => {
    const _value = props.data && em.field && props.data[em.field];
    if (typeof _value !== 'undefined') setValue(_value);
  }, [em.field, props.data]);

  useEffect(() => {
    if (typeof value === 'undefined') return;

    let _fmtd = '';
    let _value = value;
    if (_value && _value !== '') {
      _value = `${_value}`.replaceAll(',', '');
      _fmtd = formatter.format(_value);
    }

    refInput.current.value = _fmtd;
  }, [formatter, value]);

  const handleBlur = useCallback(
    (e) => {
      let _fmtd = '';
      let _value = e.target.value;
      if (_value !== '') {
        _value = `${_value}`.replaceAll(',', '');
        setValue(parseFloat(_value));
        _fmtd = formatter.format(_value);
      } else {
        setValue('');
      }

      refInput.current.value = _fmtd;

      if (props.onChange) {
        props.onChange({
          target: {
            name: e.target.name,
            value: _value,
          },
        });
      }
    },
    [formatter, props]
  );

  const handleSpinningClick = useCallback((e, action) => {
    let _value = +value;
    if (isNaN(_value) || _value==='') _value = 0;
    switch (action) {
      case '+':
        _value++;
        break;

      case '-':
        _value--;
        break;

      default:
    }
    
    setValue(_value);
    refInput.current.value = _value;

    if (props.onChange && em.field) {
      props.onChange({
        target: {
          name: em.field,
          value: _value,
        },
      });
    }
  }, [em.field, props, value]);

  return (
    <div className={`form-group ${groupClass} mb-1`}>
      <label className={`${labelClass}`}>{em && em.label ? em.label : ''}</label>
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <button className="btn btn-outline-secondary" 
            type="button"
            onClick={(e) => handleSpinningClick(e, '-')}
          >
            <i className="fas fa-minus"></i>
          </button>
        </div>

        <input
          ref={refInput}
          type="text"
          className={`form-control ${inputClass}`}
          name={em && em.field}
          // value={(props.data && em.field && props.data[em.field]) || ''}
          placeholder={em.placeholder || ''}
          onKeyDown={em.onKeyDown}
          readOnly={em.readOnly}
          onBlur={handleBlur}
          autoComplete="off"
        />

        <div className="input-group-append">
          <button className="btn btn-outline-secondary" 
            type="button"
            onClick={(e) => handleSpinningClick(e, '+')}
          >
            <i className="fas fa-plus"></i>
          </button>
        </div>        
      </div>
    </div>
  );
}

NumberSpin.defaultProps = {
  em: { field: null },
};

NumberSpin.propTypes = {
  app : PropTypes.any, 
  em : PropTypes.any, 
  data : PropTypes.any,
  digits: PropTypes.number,
  onChange : PropTypes.func,
}